import TutorialPage from './Tutorial';
import './Tutorial.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Action Creators
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loading
    setLoading,
  }, dispatch);
}

const ConnectedTutorialPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(TutorialPage);

export default ConnectedTutorialPage;



// WEBPACK FOOTER //
// ./src/pages/Tutorial/index.js